import { render, staticRenderFns } from "./kukai.vue?vue&type=template&id=fe5576c2&scoped=true&"
import script from "./kukai.vue?vue&type=script&lang=js&"
export * from "./kukai.vue?vue&type=script&lang=js&"
import style0 from "./kukai.vue?vue&type=style&index=0&id=fe5576c2&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe5576c2",
  null
  
)

export default component.exports